import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';

// Components
import Home from '../components/Home.vue';

Vue.use(Router);

const router = new Router({
	mode: 'history', // 'hash' or 'history'
	base: '/',
	routes: [
		{
			path: '/',
			name: 'Home',
			component: Home,
		},
		{
			path: '/branch-introduction',
			name: 'BranchIntroduction',
			component: () => import (/* webpackChunkName: 'branch-introduction' */ '../components/BranchIntroduction.vue'),
		},
		{
			path: '/greeting',
			name: 'Greeting',
			component: () => import (/* webpackChunkName: 'greeting' */ '../components/Greeting.vue'),
		},
		{
			path: '/entry-pre-seminar',
			name: 'EntryPreSeminar',
			component: () => import (/* webpackChunkName: 'entry-pre-seminar' */ '../components/EntryPreSeminar.vue'),
		},
		{
			path: '/contact',
			name: 'Contact',
			component: () => import (/* webpackChunkName: 'contact' */ '../components/Contact.vue'),
		},
		{
			path: '/sign-in',
			name: 'SignIn',
			component: () => import(/* webpackChunkName: 'sing-in' */ '../components/SignIn.vue'),
			beforeEnter(to, from, next) {
				if (store.getters['auth/idToken']) {
					next('/membership');
				} else {
					next();
				}
			},
		},
		{
			path: '/membership',
			name: 'Membership',
			component: () => import(/* webpackChunkName: 'membership' */ '../components/member/Membership.vue'),
			beforeEnter(to, from, next) {
				if (store.getters['auth/idToken']) {
					next();
				} else {
					next('/sign-in');
				}
			},
		},
	],
	
	scrollBehavior(to, from, savedPosition) {
		return new Promise(resolve => {
			window.addEventListener('ScrollBehavior', () => {
				let position = {x: 0, y: 0};
				if (savedPosition) {
					position = savedPosition;
				}
				if (to.hash) {
					position = {selector: to.hash}
				}
				resolve(position);
			}, {capture: false, once: true, passive: true});
		});
	},
});


export default router;
